export default "__VITE_ASSET__B$7Dz3dA__"